import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomImageWebcam from 'designer/component/element/ImageWebcam'

export const ImageWebcamSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomImageWebcam {...props} />
  </DragElementWrapper>
)

export const ImageWebcamDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomImageWebcam {...props} />
  </ElementWrapper>
)

export const imageWebcamTester = rankWith(1000, scopeEndsWith('imageWebcam'))
